import React, { useMemo } from 'react';

// utils
import { getDateTimeFromMillisecondsTZ } from '../../../utils/getDateFormat';

// enums
import imageStatusIconEnum from '../../../enums/imageStatusIconEnum';

import { IconButton, ImageListItemBar } from '@common-ui/ui';

export default function ImageThumbnail({ image = {}, style = {}, hidden = false }) {
  const { DATA = {}, sort_info } = image;
  const { imageId, img = {}, json = {} } = DATA;
  const { IRVIEWER = {}, THERMAL_IMAGE_INFO_DATA_VGPB: VGPB = {} } = json;
  const { imageDateTime = {} } = VGPB;

  const subtitle = useMemo(() => {
    const { utcMilliseconds, timeZone } = imageDateTime;
    return getDateTimeFromMillisecondsTZ(utcMilliseconds, timeZone);
  }, [imageDateTime]);

  const statusIndex = Math.floor(IRVIEWER?.status?.code / 100);

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <ImageListItemBar
          id="imageListItemBar"
          title={sort_info?.origin_path ?? 'Image'}
          subtitle={subtitle}
          hidden={hidden}
          actionIcon={
            <IconButton>
              <img src={imageStatusIconEnum?.[statusIndex]} />
            </IconButton>
          }
        />
        <img src={img?.src} alt={imageId} {...style} />
      </div>
    </div>
  );
}
